"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBSCRIBE = void 0;
const SUBSCRIBE = exports.SUBSCRIBE = 'subscribe';
